var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('app-tooltip', {
    staticClass: "sign-up__tooltip",
    attrs: {
      "hoverable": "",
      "placement": "right-end"
    },
    scopedSlots: _vm._u([{
      key: "tooltip",
      fn: function () {
        return [_c('b', [_vm._v("Не удается войти/зарегистрироваться?")]), _c('br'), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Почистите кеш и куки в браузере")]), _vm._v(" "), _c('li', [_vm._v("Выключите все расширения и VPN")]), _vm._v(" "), _c('li', [_vm._v("Воспользуйтесь другим браузером")]), _vm._v(" "), _c('li', [_vm._v("Попробуйте в режиме инкогнито")])]), _vm._v("\n        Подробные инструкции\n        "), _c('a', {
          attrs: {
            "href": "https://advt.pro/help/tekhnicheskie-voprosy/ne-udaetsya-vojtizaregistrirovatsya",
            "target": "_blank"
          }
        }, [_vm._v("\n            по ссылке.\n        ")]), _vm._v("\n        Если ничего не помогло, напишите в онлайн-чат\n        или на "), _c('a', {
          attrs: {
            "href": "mailto:support@workle.ru"
          }
        }, [_vm._v("support@workle.ru.")])];
      },
      proxy: true
    }])
  }, [_c('question-icon', {
    staticClass: "sign-up__icon-question",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }